module.exports = __webpack_public_path__ + "img/icon-select-cancel.19ae6fe1.svg";